'use client';

import { BigX, CheckMark } from '@/components/_rebrand/Icons';
import { FC } from 'react';

export interface FrontCompareProps {
  hideComponent?: boolean;
  title: React.ReactNode;
  description: string;
  eyebrow: string;
  backgroundColor?: 'green' | 'violet' | 'pink';
  frontLogo: React.ReactNode;
  frontLogoMobile: React.ReactNode;
  legacy: React.ReactNode;
  compare: {
    feature: string;
  }[],
  customerQuote: {
    logo: React.ReactNode;
    quote: React.ReactNode;
    name: string | JSX.Element;
    position: string;
  }
}

const FrontCompare: FC<FrontCompareProps> = ({
  hideComponent,
  eyebrow,
  backgroundColor = 'green',
  title,
  description,
  frontLogo,
  frontLogoMobile,
  legacy,
  compare = [],
  customerQuote,
}) => {
  return (
    <div className={`${hideComponent ? "hidden" : "block"}`}>
      <div className="hidden text-green-200 text-green-300 text-violet-200 text-violet-300 text-pink-200 text-pink-300 bg-green-700  bg-violet-700  bg-pink-700" />
      <div className={`flex mb-[96px] text-white justify-center`}>
        <div className="w-full max-w-[1385px]">
          <div className="py-11 md:py-12">
            <div
              className={`flex flex-wrap lg:flex-nowrap bg-${backgroundColor}-800 rounded-[16px] justify-between items-center px-container-mobile lg:px-[82px] py-[48px] lg:pt-[80px] lg:pb-[100px]`}>
              <div className="flex max-w-[468px] flex-wrap">
                <div className="text-14.5/18 mb-[12px] uppercase">{eyebrow}</div>
                <h2 className="font-500 tracking-tight text-30/38 md:text-36/42 mb-[16px] w-full">{title}</h2>
                <p
                  className={`text-${backgroundColor}-200 text-17/25 max-w-80 text-pretty mb-0 lg:mb-[98px]`}>{description}</p>
                <div className="flex flex-wrap w-full hidden lg:block">
                  <div className="flex">
                    {customerQuote.logo}
                  </div>
                  <div className={`text-21/28 text-${backgroundColor}-300 py-[17px]`}>
                    {customerQuote.quote}
                  </div>
                  <div className="text-white">
                    <span className="text-17/25">{customerQuote.name}</span> <span
                    className="text-15/23 uppercase">{customerQuote.position}</span>
                  </div>
                </div>
              </div>
              <div className="flex justify-end w-full">
                <div
                  className={`flex hidden lg:block bg-${backgroundColor}-700 rounded-[16px] w-full flex-wrap max-w-[718px]`}>
                  <div className={`flex w-full items-center border-b border-${backgroundColor}-600 border-solid`}>
                    <div className="flex px-[24px] pl-[32px] text-17/25 text-white w-[60%] min-h-[80px]">
                      &nbsp;
                    </div>

                    <div
                      className="flex bg-citron-500 w-[20%] justify-center rounded-tl-[8px] rounded-tr-[8px] px-[30px] pb-[30px] mt-[8px]">
                      {frontLogo}
                    </div>

                    <div className="flex w-[20%] justify-center flex-wrap text-17/25 text-center">
                      {legacy}
                    </div>
                  </div>

                  {compare.map((item, index) => {
                    return (
                      <div key={`compare-${index}`}
                           className={`flex w-full items-center border-b border-${backgroundColor}-600 border-solid last:border-none`}>
                        <div className="flex px-[24px] pl-[32px] text-17/25 text-white w-[60%]">
                          {item.feature}
                        </div>
                        <div className="flex bg-citron-500 w-[20%] justify-center py-[24px]">
                          <div className="flex ">
                            {CheckMark("#0D1D39")}
                          </div>
                        </div>
                        <div className="flex w-[20%] justify-center">
                          {BigX()}
                        </div>
                      </div>
                    )

                  })}
                </div>
              </div>
              <div
                className={`flex w-full lg:hidden bg-${backgroundColor}-700 rounded-[16px] w-full flex-wrap mt-[48px]`}>
                <div className="flex w-full justify-center pt-[20px] pb-[22px]">{frontLogoMobile}</div>
                {compare.map((item, index) => {
                  return (
                    <div key={`compare-mobile-${index}`}
                         className={`flex w-full text-14.5/22 font-500 items-center py-[20px] border-t border-${backgroundColor}-1000 border-solid`}>
                      <span className="ml-[15px] mr-[8px]">{CheckMark("#DEE948")}</span>{item.feature}</div>
                  )
                })}
              </div>

              <div className="flex flex-wrap w-full justify-center lg:hidden mt-[64px]">
                <div className="flex">
                  {customerQuote.logo}
                </div>
                <div className={`text-21/28 text-${backgroundColor}-300 py-[17px]`}>
                  {customerQuote.quote}
                </div>
                <div className="text-white">
                  <span className="text-17/25">{customerQuote.name}</span> <span
                  className="text-15/23 uppercase">{customerQuote.position}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FrontCompare;
